// Step order and specialty ordering for the find-a-teacher questionnaire.
//
// Pulled out of the component so both rules can be tested on their own: the
// order the visitor sees decides what they can pick, and the step list decides
// which question each index renders.

// Level and goals are questions about learning a language: how fluent are you,
// and what do you want the language for. A maths student answers neither —
// their stage and their purpose are both in the specialty list already, as
// "國中數學" or "考試準備".
const LANGUAGE_ONLY_STEPS = ['level', 'goals']

// The specialty list keeps every tag the subject offers. The goals the visitor
// picked only pull the matching ones to the front, because a visitor can pick
// the wrong goal, or skip the goal step, and still know the tag they want.
export function orderTagsByGoals(options, goals, goalTagOrder) {
  if (!goals || !goals.length) return options

  const preferred = new Set(goals.flatMap((goal) => goalTagOrder[goal] || []))
  const hit = options.filter((option) => preferred.has(option.value))
  const rest = options.filter((option) => !preferred.has(option.value))

  return [...hit, ...rest]
}

// A subject whose tags are all level tags has nothing left to ask, so the
// specialty step disappears rather than rendering an empty question. Steps are
// addressed by name for exactly this reason: a fixed index would put the
// schedule question under the wrong number for those subjects.
//
// @param {number} tagOptionCount
// @param {boolean} asksLevelAndGoals - false for a subject that is not a language
export function stepIdsFor(tagOptionCount, asksLevelAndGoals = true) {
  const steps = ['subject', 'level', 'goals', 'tags', 'schedule', 'situation']

  return steps.filter((step) => {
    if (step === 'tags') return Boolean(tagOptionCount)
    if (LANGUAGE_ONLY_STEPS.includes(step)) return asksLevelAndGoals
    return true
  })
}
